import { GridConfiguration, GridRequest } from '../../../../shared/grid/grid.model';

export class AnalyticsConfig extends GridConfiguration {
  constructor() {
    super();

    this.columns = [
      {
        dataField: 'fullName',
        caption: 'Name',
      },
      {
        dataField: 'acceptedNumber',
        caption: 'Accepted',
      },
      {
        dataField: 'waitlistedNumber',
        caption: 'Waitlisted',
      },
      {
        dataField: 'rejectedNumber',
        caption: 'Rejected',
      },
    ];

    this.summary = {
      totalItems: [{
        column: 'total',
        summaryType: 'sum',
        customizeText: function (data) {
          return 'Total: £ ' + (Math.round(parseFloat(data.value) * 100) / 100).toFixed(2);
        },
      }],
    };

    this.remoteOperations = {
      filtering: false,
      sorting: false,
      paging: false,
      grouping: false,
      summary: false,
    };

    this.selection = false;
    this.columnAutoWidth = true;
  }

  mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
    super.mapGridRequest(gridRequest, loadOptions);
  }
}

export class AnalyticsRequestModel extends GridRequest {
  year: number;
  month: number;
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/application-management/analitycs/config/analytics.config.ts